import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import {
  GroupList,
  userGrouplist,
  BaseUrl,
  Group_Disable,
  Group_Enable,
} from "../../services/Url";
import { enableUSer, get, post } from "../../services/Service";
import { act } from "react-dom/test-utils";
import moment from "moment";

export default function UserGroupTable(props) {
  const [checked, setChecked] = useState(true);
  const [data, setData] = useState([]);
  const [isloading, setIsloading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);

  const params = useParams();
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const singleDetail = async (pageData) => {
    let token = localStorage.getItem("token");

    let CompleteUrl = BaseUrl + userGrouplist + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: pageData,
    })
      .then(async (res) => {
        const responseData = await res.json();
        setData(responseData.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    singleDetail();
  }, [isloading]);

  const pagingHandler = (event, value) => {
    setPage(value);
    let pageData = {
      page: value,
    };
    pageData = JSON.stringify(pageData);
    singleDetail(page);
    // post(GroupList, pageData, setData, setIsloading);
  };
  const enableUserHandler = (id) => {
    setIsloading(true);
    setTimeout(() => {
      enableUSer(Group_Enable, id, setIsloading);
    }, 1000);
    setTimeout(() => {
      singleDetail(page);
    }, 1500);
  };

  const disableUserHandler = (id) => {
    setIsloading(true);
    setTimeout(() => {
      enableUSer(Group_Disable, id, setIsloading);
    }, 1000);
    setTimeout(() => {
      singleDetail(page);
    }, 1500);
  };
  const tableData = () => {
    return (
      <TableContainer className="tbl_mn br-24 br-btm-0 ">
        <Box className="table-responsive">
          <Table className="table-design table_center">
            <TableHead>
              <TableRow className="tbl_rw">
                <TableCell className="fz-18 fw-bold">Group Name</TableCell>
                <TableCell className="fz-18 fw-bold">Owner Name</TableCell>
                <TableCell className="fz-18 fw-bold">
                Members Count
                </TableCell>
                <TableCell className="fz-18 fw-bold">
                  Group Created Date
                </TableCell>
                <TableCell className="fz-18 fw-bold">Start Date</TableCell>
                <TableCell className="fz-18 fw-bold">End Date</TableCell>
                <TableCell className="fz-18 fw-bold">Recovery Method</TableCell>
                <TableCell className="fz-18 fw-bold">Banker</TableCell>
                <TableCell className="fz-18 fw-bold">Block/ Unblock</TableCell>
                <TableCell className="fz-18 fw-bold">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.docs?.length > 0 ? (
                data?.docs?.map((item, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell className="fz-16" scope="row">
                        {item.group_name}
                      </TableCell>
                      <TableCell className="fz-16">
                        {item.created_by?.first_name}{" "}
                        {item.created_by?.last_name}
                      </TableCell>
                      <TableCell className="fz-16">
                        {[...new Set(item.participants)].length}
                      </TableCell>

                      <TableCell className="fz-16">
                       
                        {moment(item.createdAt).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell className="fz-16">
                        
                        {moment(item.start_date).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell className="fz-16">
                        {" "}{item.end_date ? 
                        moment(item.end_date).format("DD-MM-YYYY") : 'Not Defined'}
                      </TableCell>
                      <TableCell className="fz-16">
                        {item.loss_recovery}
                      </TableCell>
                      <TableCell className="fz-16">
                        {item.created_by?._id === params.id ? "Yes" : "No"}
                      </TableCell>

                      <TableCell
                        className="fz-16"
                        style={{ textAlign: "center" }}
                      >
                        <Switch
                          checked={item.status}
                          onChange={() =>
                            item.status
                              ? disableUserHandler(item?._id)
                              : enableUserHandler(item?._id)
                          }
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </TableCell>
                      <TableCell className="fz-16">
                        {/* <Link to={`/editgroup/${item._id}`} style={{ marginRight: "8px" }}>
                          <EditIcon />
                        </Link> */}
                        <Link to={`/groupdetail/${item._id}`}>
                          <RemoveRedEyeIcon />
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                <TableCell colSpan={12} className="empty-text">
                  No data found
                </TableCell>
              </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
          }}
        >
          {data?.docs?.length > 0 ? (
            <Stack spacing={2}>
              <Pagination
                count={data?.docs?.totalPages}
                onChange={pagingHandler}
              />
            </Stack>
          ) : (
            ""
          )}
        </Box>
      </TableContainer>
    );
  };

  return (
    <Box
      display="flex"
      className="box-wrapper br-24 table_bx"
      flexDirection="column"
      justifyContent="start"
    >
      <div className="heading-btn_wrapper">
        <h5 className="fz-20 fw-bold">User Groups Management</h5>
      </div>
      {tableData()}
    </Box>
  );
}
